import React from 'react';

const Blob = () => {
    return (
        <div>
            <svg
                width="240"
                height="577"
                viewBox="0 0 240 577"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    zIndex: '-1',
                }}
            >
                <g clipPath="url(#clip0_764_9847)">
                    <g style={{ mixBlendMode: 'soft-light' }} opacity="0.1" filter="url(#filter0_d_764_9847)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M-79.916 555.039C-98.5983 600.168 -70.8326 655.131 -95.8197 697.098C-121.736 740.626 -166.967 771.436 -216.098 783.764C-263.059 795.547 -316.721 790.489 -356.177 762.426C-391.963 736.971 -374.493 671.44 -410.119 645.761C-476.022 598.259 -614.337 642.001 -632.965 562.921C-649.634 492.157 -504.131 497.941 -458.215 441.581C-417.975 392.188 -441.975 306.859 -392.081 267.245C-337.474 223.89 -261.184 227.66 -191.495 229.818C-98.3896 232.7 45.8956 193.622 76.1279 281.74C111.026 383.457 -38.784 455.681 -79.916 555.039Z"
                            fill="white"
                        />
                    </g>
                    <g style={{ mixBlendMode: 'soft-light' }} opacity="0.1" filter="url(#filter1_d_764_9847)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M113.242 572.551C68.1717 670.302 -121.759 575.086 -190.209 658.199C-249.742 730.485 -129.113 855.31 -182.808 932.021C-235.041 1006.64 -350.535 1038.85 -437.47 1011.45C-524.385 984.063 -543.514 871.652 -600.31 800.463C-659.717 726.001 -765.797 679.735 -777.505 585.244C-789.398 489.267 -750.275 360.011 -658.826 328.23C-553.607 291.664 -462.854 443.056 -351.602 437.233C-287.663 433.887 -282.454 312.057 -218.796 305.2C-158.72 298.729 -121.611 369.517 -74.5697 407.393C-8.00317 460.991 149.009 494.978 113.242 572.551Z"
                            fill="white"
                        />
                    </g>
                    <g style={{ mixBlendMode: 'soft-light' }} opacity="0.1" filter="url(#filter2_d_764_9847)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M81.0296 402.063C126.262 490.259 310.684 567.697 244.603 641.635C161.094 735.074 2.93981 618.798 -121.959 629.187C-156.283 632.042 -177.156 667.191 -209.365 679.397C-257.677 697.703 -304.149 722.097 -355.622 717.73C-439.709 710.595 -541.105 714.033 -592.196 646.914C-643.25 579.842 -634.42 475.962 -597.266 400.276C-562.042 328.524 -466.609 317.786 -405.385 266.372C-340.522 211.903 -312.547 108.959 -229.647 91.5654C-144.961 73.7969 -53.4797 118.563 7.69498 179.702C64.2895 236.264 44.5193 330.873 81.0296 402.063Z"
                            fill="white"
                        />
                    </g>
                </g>
                <defs>
                    <filter
                        id="filter0_d_764_9847"
                        x="-712.288"
                        y="145.624"
                        width="863.641"
                        height="714.082"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="37" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_764_9847" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_764_9847" result="shape" />
                    </filter>
                    <filter
                        id="filter1_d_764_9847"
                        x="-857.583"
                        y="226.785"
                        width="1046.05"
                        height="864.33"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="37" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_764_9847" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_764_9847" result="shape" />
                    </filter>
                    <filter
                        id="filter2_d_764_9847"
                        x="-705.824"
                        y="9.63477"
                        width="1034.57"
                        height="778.609"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="37" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_764_9847" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_764_9847" result="shape" />
                    </filter>
                    <clipPath id="clip0_764_9847">
                        <rect width="240" height="577" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export default Blob;
